import React, { useState, useEffect } from 'react';
import { Joystick } from './CommonUI';

const HUD = ({ gameState, currentUserId }) => {
  const currentPlayer = gameState.entities[currentUserId];
  
  if (!currentPlayer) return null;
  
  const timeRemaining = Math.ceil(gameState.timeRemaining / 1000);
  const colorChangeTime = Math.ceil(currentPlayer.colorChangeTime / 1000);
  
  return (
    <div
      className="absolute top-0 left-0 right-0 p-2 bg-black bg-opacity-50 text-gray-300 font-game"
      style={{ userSelect: 'none' }}
    >
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <p>Score: {currentPlayer.score}/15</p>
          <div className="flex items-center gap-2">
            <p>Current:</p>
            <div 
              style={{ 
                width: '20px', 
                height: '20px', 
                backgroundColor: currentPlayer.currentColor,
                borderRadius: '50%',
                border: '1px solid white'
              }} 
            />
          </div>
          <div className="flex items-center gap-2">
            <p>Next ({colorChangeTime}s):</p>
            <div 
              style={{ 
                width: '20px', 
                height: '20px', 
                backgroundColor: currentPlayer.nextColor,
                borderRadius: '50%',
                border: '1px solid white',
                opacity: 0.7
              }} 
            />
          </div>
        </div>
        <p>Time: {timeRemaining}s</p>
      </div>
    </div>
  );
};

const GameOverModal = ({ results, onFinish, isEliminated = false, gameOver = false }) => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-4 rounded-lg text-black">
        <h2 className="text-xl font-bold mb-4">
          {isEliminated && !gameOver ? "You've been eliminated!" : "Game Over!"}
        </h2>
        <div className="mb-4">
          {gameOver ? (
            <>
              {results.winners.length > 0 && (
                <p>Winners: {results.winners.join(', ')}</p>
              )}
              {results.losers.length > 0 && (
                <p>Losers: {results.losers.join(', ')}</p>
              )}
            </>
          ) : (
            <p>You touched a wrong colored zone! The game continues for other players.</p>
          )}
        </div>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={onFinish}
        >
          OK
        </button>
      </div>
    </div>
  );
};

function GameUI({ gameState, gameInterface, onFinishGame }) {
  const [, forceUpdate] = useState();

  const handleMove = (dx, dy) => {
    gameInterface.sendGameEvent('joystick_move', {dx, dy, userId: gameInterface.userId});
  }

  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate({});
    }, 10);
    return () => clearInterval(interval);
  }, []);

  const currentPlayer = gameState.entities[gameInterface.userId];
  const isPlayerEliminated = currentPlayer && currentPlayer.isEliminated;
  const isGameOver = gameState.isGameOver;

  return (
    <>
      <HUD gameState={gameState} currentUserId={gameInterface.userId} />
      <Joystick onMove={handleMove} position={{ bottom: '20px', right: '20px' }} />
      {(isGameOver || isPlayerEliminated) && (
        <GameOverModal
          results={gameState.results || { winners: [], losers: [] }}
          onFinish={onFinishGame}
          isEliminated={isPlayerEliminated}
          gameOver={isGameOver}
        />
      )}
    </>
  );
}

export default GameUI;
